import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/denied/usage.deniedFeed.query.gql"
import type {
  UsageLicenseDeniedFeedQuery,
  UsageLicenseDeniedFeedQueryVariables,
} from "@/v2-backoffice-client/usage/denied/__types__/usage.deniedFeed.query"

type Options = QueryHookOptions<
  UsageLicenseDeniedFeedQuery,
  UsageLicenseDeniedFeedQueryVariables
>

export function useUsageLicenseDeniedFeedQuery(options?: Options) {
  return useQuery<
    UsageLicenseDeniedFeedQuery,
    UsageLicenseDeniedFeedQueryVariables
  >(query, options)
}
